import {useDispatch, useSelector} from "react-redux";
import {RegionSelectProps} from "../../Filters";
import React from "react";
import {selectedTypeIdSelector, setSelectedTypeId} from "../filtersSlice";

export const useSelectedTypeId = () => {
    const dispatch = useDispatch();
    const typeId = useSelector(selectedTypeIdSelector);

    const onSelectType: NonNullable<RegionSelectProps['onSelect']> = React.useCallback((id) => {
        dispatch(setSelectedTypeId({ id }));
    }, [dispatch]);
    return {
        typeId,
        onSelectType
    };
}